import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full max-w-md space-y-6 rounded-2xl border border-gray-200 bg-white p-8 text-left shadow-lg sm:text-center"
}
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg font-semibold leading-snug text-red-600"
}
const _hoisted_4 = { class: "whitespace-pre-line text-base leading-relaxed text-gray-600" }
const _hoisted_5 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarLoader = _resolveComponent("BarLoader")!
  const _component_CognitoBrandedShell = _resolveComponent("CognitoBrandedShell")!

  return (_openBlock(), _createBlock(_component_CognitoBrandedShell, null, {
    default: _withCtx(() => [
      (_ctx.errorDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.errorHeading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorHeading), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorDetail), 1)
            ]),
            _createElementVNode("p", _hoisted_5, " Returning to the home screen in " + _toDisplayString(_ctx.redirectSecondsRemaining) + " seconds… ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "w-full rounded-lg bg-[#9489F5] px-4 py-3 text-sm font-medium text-white shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#9489F5] focus:ring-offset-2 focus:ring-offset-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToHome && _ctx.returnToHome(...args)))
            }, " Return to home ")
          ]))
        : (_openBlock(), _createBlock(_component_BarLoader, {
            key: 1,
            variant: "spinner",
            theme: "light",
            contained: "",
            message: "Verifying your account…"
          }))
    ]),
    _: 1
  }))
}